<template>
  <div id="top-nav" style="position: relative; z-index: 2">
    <!-- <div class="uk-background-muted uk-visible@s">
      <div class="uk-grid uk-margin-left uk-margin-right uk-child-width-1-3" uk-grid>
        <div class="uk-flex uk-flex-small uk-width-2-3@s">
          <a href="https://api.whatsapp.com/send/?phone=6281113901291&text=Halo" class="font-black uk-margin-small-bottom uk-margin-small-top"><span uk-icon="icon: whatsapp"></span> Message Us: +6281113901291</a>
          <a href="mailto:roomismarthome@gmail.com" class="font-black uk-margin-left uk-margin-small-bottom uk-margin-small-top"><span uk-icon="icon: mail"></span> Support: roomismarthome@gmail.com</a>
        </div>
        <div class="uk-flex uk-flex-right uk-flex-middle uk-text-center uk-width-1-3@s">
          <div class="uk-margin-small-right">
            <a href="https://www.instagram.com/roomiindonesia" uk-icon="icon: instagram"></a>
          </div>
          <div class="uk-margin-small-right">
            <a href="https://www.tiktok.com/@roomiindonesia" uk-icon="icon: tiktok"></a>
          </div>
          <div class="uk-margin-small-right">
            <a href="https://www.youtube.com/@RoomiIndonesia" uk-icon="icon: youtube"></a>
          </div>
          <div>
            <a href="https://www.facebook.com/roomismarthome" uk-icon="icon: facebook"></a>
          </div>
        </div>
      </div>
    </div> -->
    <div class="uk-container">
      <!-- DESKTOP -->
      <nav
        class="uk-navbar-container uk-visible@s"
        uk-navbar="mode: click; dropbar: true;"
      >
        <div class="uk-navbar-left">
          <ul class="uk-navbar-nav" id="desktopNavbar">
            <li class="uk-padding-remove-left">
              <router-link to="/" class="uk-padding-remove-left">
                <img
                  src="../assets/icon/logo-white.png"
                  id="main-logo"
                  class="uk-navbar-item uk-logo"
                  alt="../assets/ROOMI_LOGO-03.png"
                  style="
                    width: 140px;
                    min-height: 30px;
                    max-height: 50px;
                    transform: scaleX(0.9);
                    padding: 0;
                    margin-right: 30px;
                  "
                />
              </router-link>
            </li>
            <li v-for="menu in menus" :key="menu.name">
              <router-link
                v-if="menu.link != ''"
                :to="`/${menu.link}`"
                class="custom-link"
                ><span class="uk-text-default uk-text-capitalize">{{ menu.name }}</span></router-link
              >
              <div v-else-if="menu.name === 'Collections'" class="uk-inline uk-margin-top">
                <button style="padding-top: 8px" class="uk-button uk-button-link custom-link">
                  <span class="uk-text-default uk-text-capitalize font-white">{{ menu.name }}</span>
                </button>
                <div style="padding: 0px !important; min-width:650px; height: 60vh" uk-dropdown="">
                  <div class="uk-grid-collapse" uk-grid>
                    <div class="uk-width-1-2@s uk-padding">
                      <ul class="uk-nav uk-dropdown-nav uk-text-primary">
                        <li :class="{'uk-margin-bottom': index < menu.childs.length - 1}" v-for="(collect, index) in menu.childs" :key="index">
                          <a @click="openCategory(collect.seo_url)" href="#" class="uk-text-primary uk-flex uk-flex-between categoryMenu"><span class="uk-text-default">{{ collect.name }}</span><span uk-icon="chevron-right"></span></a>
                          <div style="box-shadow: none !important; padding: 0px !important; padding-left: 8px !important"lass="uk-dropdown dropdown-right-custom" uk-dropdown="pos: right-top;">
                            <ul class="uk-nav uk-dropdown-nav">
                              <li v-for="(product, indexPro) in collect.products" :key="product.name" @click="openProduct(product.seo_url, collect.seo_url)" :class="{'uk-margin-small-bottom': indexPro < collect.products.length - 1}"><a class="uk-text-primary categoryMenu"><span class="uk-text-small">{{ product.name }}</span></a></li>
                            </ul>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div v-else-if="menu.name === 'Collections'" class="uk-inline uk-margin-top">
                <button style="padding-top: 8px" class="uk-button uk-button-link custom-link">
                  <span class="uk-text-default uk-text-capitalize font-white">{{ menu.name }}</span>
                </button>
                <div style="padding: 0px !important; max-height:65vh" uk-dropdown="stretch: true">
                  <div class="uk-grid-collapse" uk-grid>
                    <div class="uk-width-1-2@s uk-padding">
                      <div class="uk-grid" uk-grid>
                        <div class=" uk-width-1-2@s">
                          <ul class="uk-nav uk-dropdown-nav uk-text-primary">
                            <li :class="{'uk-margin-bottom': index < menu.childs.length - 1}" v-for="(collect, index) in menu.childs" :key="index">
                              <a @click="openCategory(collect.seo_url)" href="#" class="uk-text-primary uk-flex uk-flex-between categoryMenu"><span class="uk-text-default">{{ collect.name }}</span><span uk-icon="chevron-right"></span></a>
                              <div style="box-shadow: none !important; padding: 0px !important; padding-left: 8px !important"lass="uk-dropdown dropdown-right-custom" uk-dropdown="pos: right-top;">
                                <ul class="uk-nav uk-dropdown-nav">
                                  <li v-for="(product, indexPro) in collect.products" :key="product.name" @click="openProduct(product.seo_url, collect.seo_url)" :class="{'uk-margin-small-bottom': indexPro < collect.products.length - 1}"><a class="uk-text-primary categoryMenu"><span class="uk-text-small">{{ product.name }}</span></a></li>
                                </ul>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="uk-width-1-2@s">
                      <img src="https://api.roomi.co.id/images/home/aset website-06.jpg" alt="TV Image">
                    </div>
                  </div>
                </div>
              </div> -->
              <div v-else class="uk-inline uk-margin-top">
                <button style="padding-top: 8px" class="uk-button uk-button-link custom-link">
                  <span class="uk-text-default uk-text-capitalize font-white">Store</span>
                </button>
                <div style="padding: 0px !important; min-width:450px; height: 15vh" uk-dropdown="">
                  <div class="uk-grid-collapse" uk-grid>
                    <div class="uk-width-1-2@s uk-padding">
                      <ul class="uk-nav uk-dropdown-nav uk-text-primary">
                        <li class="uk-margin-bottom">
                          <router-link
                            to="/store"
                            class="custom-link categoryMenu"
                            ><span class="uk-text-default uk-text-capitalize uk-text-primary">Offline Store</span></router-link
                          > 
                        </li>
                        <li class="uk-margin-bottom">
                          <a href="#" class="uk-text-primary uk-flex uk-flex-between categoryMenu"><span class="uk-text-default">Online Store</span><span uk-icon="chevron-right"></span></a>
                          <div style="box-shadow: none !important; padding: 0px !important; padding-left: 8px !important" class="uk-dropdown dropdown-right-custom" uk-dropdown="animation: slide-left; duration: 300; pos: right-top">
                            <ul class="uk-nav uk-dropdown-nav">
                              <li class="uk-margin-small-bottom"><a href="https://tokopedia.com/roomiid"class="uk-text-primary categoryMenu"><span class="uk-text-small">Tokopedia</span></a></li>
                              <li ><a href="https://www.tiktok.com/@roomiindonesia?_t=8oTj8kPhvXu&_r=1" class="uk-text-primary categoryMenu"><span class="uk-text-small">TikTok</span></a></li>
                            </ul>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <!-- <li
              style="width: 95px"
              v-for="(item, index) in menus"
              :key="index"
              :class="
                item.link == '' && item.childs.length > 0
                  ? 'subnav-dropdown-parent'
                  : ''
              "
            >
              <a href="#" v-if="item.link == '' && item.childs.length > 0">{{
                item.name
              }}</a>
              <div
                v-if="
                  item.name.toLowerCase() == 'product' && item.childs.length > 0
                "
                class="
                  uk-navbar-dropdown uk-navbar-dropdown-width-4
                  subnav-dropdown
                "
                id="navbarProduct"
              >
                <div
                  class="uk-flex uk-flex-middle"
                  uk-grid
                  uk-height-match="target: > div"
                >
                  <div
                    class="uk-width-1-4"
                    v-for="(child, i) in item.childs"
                    :key="i"
                  >
                    <ul class="uk-nav uk-navbar-dropdown-nav subnav">
                      <li class="uk-nav-header">{{ child.name }}</li>
                      <li v-for="(product, j) in child.products" :key="j">
                        <router-link :to="`/product/${product.seo_url}`">{{
                          product.name
                        }}</router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                v-else-if="item.childs.length > 0"
                class="
                  uk-navbar-dropdown uk-navbar-dropdown-width-4
                  subnav-dropdown
                "
              >
                <div
                  class="uk-flex uk-flex-middle"
                  uk-grid
                  uk-height-match="target: > div"
                >
                  <div
                    class="uk-width-1-4"
                    v-for="(child, i) in item.childs"
                    :key="i"
                  >
                    <ul class="uk-nav uk-navbar-dropdown-nav subnav">
                      <li class="uk-nav-header">
                        <router-link :to="`/${child.link}`">{{
                          child.name
                        }}</router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <router-link
                :to="item.link != '' ? `/${item.link}` : '#'"
                v-else-if="item.link != ''"
                >{{ item.name }}</router-link
              >
            </li> -->
          </ul>
        </div>

        <div class="uk-navbar-right">
          <ul class="uk-navbar-nav">
            <li style="align-self: center; margin-right: 0.9vw">
              <form
                class="uk-search uk-search-default uk-margin-auto-vertical"
                id="topSearchForm"
                v-show="topSearchForm"
                @submit.prevent="searchProduct()"
              >
                <input
                  class="uk-text-primary"
                  type="search"
                  placeholder="SEARCH OUR SITE HERE"
                  v-model="keyword"
                />
              </form>
            </li>
            <li>
              <button
                class="uk-navbar-toggle"
                uk-search-icon
                ration="0.8"
                style="padding: 0; font-size: 12px; width: 20px;color:white !important;"
                v-on:click="showTopSearchForm"
              ></button>
            </li>
            <!-- <li style="margin-left: 10px" v-if="!IS_AUTH">
              <div style="height: 100%; display: flex; align-items: center">
                <router-link
                  to="/service_center"
                  class="uk-button uk-button-default uk-button-small"
                  style="
                    color: white;
                    padding: 0 15px;
                    font-size: 0.7vw;
                    background-color: rgb(255, 255, 255);
                    color: rgb(45, 41, 43);
                    border-color: #ffffff;
                    border-radius: 4px;
                  "
                  >OUR STORE</router-link
                >
              </div>
            </li> -->
            <!-- 
              <li style="margin-left: 10px" v-if="!IS_AUTH">
              <div style="height: 100%; display: flex; align-items: center">
                <a
                  href="#modal-login"
                  uk-toggle
                  class="uk-button uk-button-default uk-button-small"
                  style="
                    color: white;
                    padding: 0 15px;
                    font-size: 0.7vw;
                    background-color: rgb(255, 255, 255);
                    color: rgb(45, 41, 43);
                    border-color: #ffffff;
                  "
                  >Login</a
                >
              </div>
            </li>
            <li style="margin-left: 10px" v-if="!IS_AUTH">
              <div style="height: 100%; display: flex; align-items: center">
                <a
                  href="#modal-register"
                  uk-toggle
                  class="uk-button uk-button-default uk-button-small"
                  style="color: white; padding: 0 15px; font-size: 0.7vw"
                  >Register</a
                >
              </div>
            </li>
            <li style="margin-left: 20px; margin-right: 15px" v-if="IS_AUTH">
              <div
                style="
                  height: 100%;
                  display: flex;
                  align-items: center;
                  width: 20px;
                "
              >
                <router-link
                  to="/cart"
                  uk-icon="icon: cart"
                  style="position: relative"
                >
                  <span class="uk-badge cart-badge">{{ COUNT_CART }}</span>
                </router-link>
              </div>
            </li>
            <li style="margin-left: 10px" v-if="IS_AUTH">
              <div style="height: 100%; display: flex; align-items: center">
                <router-link
                  to="/store"
                  class="uk-button uk-button-default uk-button-small"
                  style="
                    color: white;
                    padding: 0 15px;
                    font-size: 0.7vw;
                    background-color: rgb(255, 255, 255);
                    color: rgb(45, 41, 43);
                    border-color: #ffffff;
                  "
                  >Store</router-link
                >
              </div>
            </li>
            <li style="margin-left: 10px" v-if="IS_AUTH">
              <div
                style="
                  height: 100%;
                  display: flex;
                  align-items: center;
                  position: relative;
                "
              >
                <div class="uk-inline">
                  <button
                    class="uk-button uk-button-default uk-button-small"
                    style="color: white; padding: 0 15px; font-size: 0.7vw"
                    type="button"
                    @click="showDropdownAccount = !showDropdownAccount"
                    v-click-outside="closeDropdown"
                  >
                    {{
                      fullnameTemp.split(" ")[0].length > 10
                        ? fullnameTemp.split(" ")[0].slice(0, 10) + "..."
                        : fullnameTemp.split(" ")[0]
                    }}
                    <span
                      class="uk-badge badge-notification-order"
                      v-if="GET_NOTIF_ORDER > 0"
                      >{{ GET_NOTIF_ORDER }}</span
                    >
                  </button>
                  <div class="dropdown-menu-user" v-if="showDropdownAccount">
                    <ul>
                      <li>
                        <router-link to="/profile/transaction"
                          >History Transaction
                          <span class="uk-badge" v-if="GET_NOTIF_ORDER > 0">{{
                            GET_NOTIF_ORDER
                          }}</span></router-link
                        >
                      </li>
                      <li>
                        <router-link to="/profile">My Profile</router-link>
                      </li>
                      <li class="dropdown-logout">
                        <a href="javascript:void(0)" @click="logout">Logout</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li> 
            -->
          </ul>
        </div>
      </nav>

      <!-- MOBILE -->
      <nav class="uk-navbar-container" uk-dropnav id="mobileNavbar">
        <div class="uk-navbar-left nav-overlay">
          <ul class="uk-navbar-nav">
            <li>
              <a
                class="uk-navbar-toggle"
                uk-navbar-toggle-icon
                uk-toggle="target: #offcanvas-slide"
                href="#"
              ></a>
            </li>
          </ul>
        </div>

        <div id="offcanvas-slide" uk-offcanvas="mode: reveal;">
          <div class="uk-offcanvas-bar">
            <ul class="uk-nav uk-nav-parent-icon" uk-nav>
              <li class="uk-margin-small">
                <router-link to="/" class="uk-offcanvas-close"
                  >Home</router-link
                >
              </li>
              <li :class="{ 'uk-margin-small': menu.name !== 'Collections' && menu.name !== 'store' }" v-for="menu in menus" :key="menu.name">
                <router-link v-if="menu.link != ''" :to="`/${menu.link}`" class="uk-offcanvas-close"
                  >{{ menu.name }}</router-link
                >
                <div v-else-if="menu.name === 'Collections'">
                  <a href>{{ menu.name }} <span uk-drop-parent-icon></span></a>
                  <div class="uk-dropdown uk-dropdown-mobile uk-dropdown-shadow-none uk-background-secondary uk-box-shadow-none uk-margin-remove uk-padding-remove">
                    <ul class="uk-nav uk-dropdown-nav">
                      <li v-for="(collect, index) in menu.childs" :key="index">
                        <a href>{{ collect.name }} <span uk-drop-parent-icon></span></a>
                        <div class="uk-dropdown uk-dropdown-mobile uk-dropdown-shadow-none uk-background-secondary uk-box-shadow-none uk-margin-remove uk-padding-remove">
                          <ul class="uk-nav uk-dropdown-nav">
                            <li v-for="(product, indexPro) in collect.products" :key="product.name"  @click="openProduct(product.seo_url, collect.seo_url)" class="uk-margin-small-bottom"><a class="uk-text-primary"><span class="uk-text-small">{{ product.name }}</span></a></li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div v-else>
                  <a href>Store <span uk-drop-parent-icon></span></a>
                  <div class="uk-dropdown uk-dropdown-mobile uk-dropdown-shadow-none uk-background-secondary uk-box-shadow-none uk-margin-remove uk-padding-remove">
                    <ul class="uk-nav uk-dropdown-nav">
                      <li>
                        <router-link to="/store" class="uk-offcanvas-close"
                          >Offline Store</router-link
                        >
                      </li>
                      <li>
                        <a href>Online Store<span uk-drop-parent-icon></span></a>
                        <div class="uk-dropdown uk-dropdown-mobile uk-dropdown-shadow-none uk-background-secondary uk-box-shadow-none uk-margin-remove uk-padding-remove">
                          <ul class="uk-nav uk-dropdown-nav">
                            <li class="uk-margin-small-bottom"><a href="https://tokopedia.com/roomiid" class="uk-text-primary"><span class="uk-text-small">Tokopedia</span></a></li>
                            <li class="uk-margin-small-bottom"><a href="https://www.tiktok.com/@roomiindonesia?_t=8oTj8kPhvXu&_r=1" class="uk-text-primary"><span class="uk-text-small">TikTok</span></a></li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <!-- <li>
                <a href>Collections <span uk-drop-parent-icon></span></a>
                <div class="uk-dropdown uk-dropdown-mobile uk-dropdown-shadow-none uk-background-secondary uk-box-shadow-none uk-margin-remove uk-padding-remove">
                  <ul class="uk-nav uk-dropdown-nav">
                    <li v-for="(collect, index) in collectionsData" :key="index">
                      <a href>{{ collect.category }} <span uk-drop-parent-icon></span></a>
                      <div class="uk-dropdown uk-dropdown-mobile uk-dropdown-shadow-none uk-background-secondary uk-box-shadow-none uk-margin-remove uk-padding-remove">
                        <ul class="uk-nav uk-dropdown-nav">
                          <li v-for="(product, indexPro) in collect.products" :key="product.name"  @click="openProduct(product.name, collect.url)" class="uk-margin-small-bottom"><a class="uk-text-primary"><span class="uk-text-small">{{ product.name }}</span></a></li>
                          
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </li> -->
              <!-- <li class="uk-margin-small">
                <router-link to="/about" class="uk-offcanvas-close"
                  >ABOUT</router-link
                >
              </li>
              <li class="uk-parent uk-margin-small">
                <a href="#">PRODUCT</a>
                <ul class="uk-nav-sub">
                  <div v-for="(category, i) in categories" :key="i">
                    <li class="uk-nav-header">{{ category.category }}</li>
                    <li v-for="(product, j) in category.products" :key="j">
                      <router-link
                        :to="`/product/${product.id_product}`"
                        class="uk-offcanvas-close"
                        >{{ product.name }}</router-link
                      >
                    </li>
                  </div>
                </ul>
              </li>
              <li class="uk-margin-small support">
                <router-link to="/support" class="uk-offcanvas-close"
                  >SUPPORT</router-link
                >
              </li> -->
              <!-- <li
                :class="
                  item.link == '' && item.childs.length > 0
                    ? 'uk-parent uk-margin-small'
                    : 'uk-margin-small'
                "
                v-for="(item, index) in menus"
                :key="index"
              >
                <a href="#" v-if="item.link == '' && item.childs.length > 0">{{
                  item.name.toUpperCase()
                }}</a>
                <ul
                  class="uk-nav-sub"
                  v-if="
                    item.link == '' &&
                    item.childs.length > 0 &&
                    item.name.toLowerCase() == 'product'
                  "
                >
                  <div v-for="(child, i) in item.childs" :key="i">
                    <li class="uk-nav-header">{{ child.name }}</li>
                    <li v-for="(product, j) in child.products" :key="j">
                      <router-link
                        :to="`/product/${product.seo_url}`"
                        class="uk-offcanvas-close"
                        >{{ product.name.toUpperCase() }}</router-link
                      >
                    </li>
                  </div>
                </ul>
                <ul
                  class="uk-nav-sub"
                  v-else-if="item.link == '' && item.childs.length > 0"
                >
                  <li v-for="(child, i) in item.childs" :key="i">
                    <router-link :to="`/${child.link}`">{{
                      child.name.toUpperCase()
                    }}</router-link>
                  </li>
                </ul>
                <router-link
                  :to="item.link != '' ? `/${item.link}` : '#'"
                  class="uk-offcanvas-close"
                  v-else
                  >{{ item.name.toUpperCase() }}</router-link
                >
              </li> -->
              <!-- <hr class="uk-margin-remove-top" />
              <li class="uk-margin-small">
                <router-link to="/service_center" class="uk-offcanvas-close"
                  >SERVICE CENTER</router-link
                >
              </li>
              <li class="uk-margin-small" v-if="IS_AUTH">
                <router-link to="/cart" class="uk-offcanvas-close"
                  >CART</router-link
                >
              </li> -->
              <!-- <li class="uk-margin-small" v-if="!IS_AUTH">
                <button
                  class="
                    uk-width-1-1
                    uk-button
                    uk-button-default
                    uk-button-small
                    uk-offcanvas-close
                  "
                  style="
                    color: white;
                    padding: 0 15px;
                    font-size: 0.7vw;
                    background-color: rgb(255, 255, 255);
                    color: rgb(45, 41, 43);
                    border-color: #ffffff;
                  "
                  @click="openLoginModal()"
                >
                  Login
                </button>
              </li>
              <li class="uk-margin-small" v-if="!IS_AUTH">
                <button
                  class="
                    uk-width-1-1
                    uk-button
                    uk-button-default
                    uk-button-small
                    uk-offcanvas-close
                  "
                  @click="openRegisterModal()"
                >
                  Register
                </button>
              </li>
              <li class="uk-parent uk-margin-small" v-if="IS_AUTH">
                <a href="#"
                  >{{
                    fullnameTemp.split(" ")[0].length > 10
                      ? fullnameTemp.split(" ")[0].slice(0, 10) + "..."
                      : fullnameTemp.split(" ")[0]
                  }}
                  <span
                    class="uk-badge badge-notification-mobile"
                    style="margin-left: 5px"
                    v-if="GET_NOTIF_ORDER > 0"
                    >{{ GET_NOTIF_ORDER }}</span
                  >
                </a>
                <ul class="uk-nav-sub">
                  <li>
                    <router-link
                      to="/profile/transaction"
                      class="uk-offcanvas-close"
                      >History
                      <span
                        class="uk-badge badge-notification-mobile"
                        v-if="GET_NOTIF_ORDER > 0"
                        style="float: right"
                        >{{ GET_NOTIF_ORDER }}</span
                      ></router-link
                    >
                  </li>
                  <li>
                    <router-link to="/profile" class="uk-offcanvas-close"
                      >Profile</router-link
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0)"
                      class="uk-offcanvas-close"
                      @click="logout"
                      >Logout</a
                    >
                  </li>
                </ul>
              </li> -->
            </ul>
          </div>
        </div>

        <div class="uk-navbar-center nav-overlay">
          <ul class="uk-navbar-nav">
            <li>
              <router-link to="/">
                <img
                  src="../assets/icon/logo-white.png"
                  id="main-logo"
                  class="uk-navbar-item uk-logo"
                  alt="../assets/ROOMI_LOGO-03.png"
                  style="
                    max-width: 120px;
                    min-height: 10px;
                    max-height: 40px;
                    transform: scaleX(0.9);
                    padding-left: 0;
                  "
                />
              </router-link>
            </li>
          </ul>
        </div>

        <div
          class="uk-navbar-right nav-overlay"
          style="display: inline-block; position: absolute; top: 0; right: 0"
        >
          <ul class="uk-navbar-nav">
            <li>
              <a
                class="uk-navbar-toggle uk-margin-small-right"
                uk-search-icon
                uk-toggle="target: .nav-overlay; animation: uk-animation-fade"
                href="#"
              ></a>
            </li>
          </ul>
        </div>

        <div
          class="nav-overlay uk-navbar-left uk-flex-1"
          id="searchMobile"
          hidden
        >
          <div class="uk-navbar-nav uk-width-expand">
            <form
              class="uk-search uk-search-navbar uk-width-1-1"
              @submit.prevent="searchProduct()"
            >
              <span uk-search-icon></span>
              <input
                class="uk-search-input"
                type="search"
                placeholder="Search..."
                autofocus
                style="font-size: 12px;"
                v-model="keyword"
              />
            </form>
          </div>

          <a
            class="uk-navbar-toggle"
            uk-close
            uk-toggle="target: .nav-overlay; animation: uk-animation-fade"
            href="#"
          ></a>
        </div>
      </nav>
    </div>
    <div
      class="uk-alert-danger"
      uk-alert
      style="margin-bottom: 0px"
      v-if="IS_AUTH && GET_USER.verification_phone == 0"
    >
      <div class="uk-container uk-text-center">
        <div>
          Immediately do the Verification No. Your mobile is
          <router-link to="/profile/verification_phone">here</router-link>
        </div>
      </div>
    </div>

    <div id="modal-search" class="uk-modal-full uk-modal" uk-modal>
      <div
        class="uk-modal-dialog uk-flex uk-flex-center uk-flex-middle"
        uk-height-viewport
      >
        <button class="uk-modal-close-full" type="button" uk-close></button>
        <form class="uk-search uk-search-large">
          <input
            class="uk-search-input uk-text-center uk-text-primary"
            type="search"
            placeholder="Search..."
            autofocus
          />
        </form>
      </div>
    </div>

    <!-- <div id="modal-login" class="uk-flex-top" uk-modal>
      <div
        class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical"
        style="width: 450px"
      >
        <button class="uk-modal-close-default" type="button" uk-close></button>

        <div class="uk-modal-header">
          <div class="uk-modal-title">Login</div>
        </div>
        <div class="uk-modal-body">
          <form @submit.prevent="loginAction()">
            <div
              class="uk-alert-danger"
              uk-alert
              v-if="login.messageError != ''"
            >
              <a
                class="uk-alert-close"
                uk-close
                href="javascript:void(0);"
                @click="login.messageError = ''"
              ></a>
              <p>
                {{ login.messageError }}
              </p>
            </div>
            <div class="uk-margin">
              <input
                type="text"
                class="uk-input"
                placeholder="Email Address / Phone Number"
                v-model="login.email"
                required
              />
            </div>
            <div class="uk-margin">
              <input
                type="password"
                class="uk-input"
                placeholder="Password"
                v-model="login.password"
                required
              />
            </div>
            <div class="uk-margin">
              <button
                class="uk-button uk-button-primary uk-width-1-1"
                :disabled="disabledButtonLogin || login.loadingButtonLogin"
                type="submit"
              >
                <div uk-spinner v-if="login.loadingButtonLogin"></div>
                <div v-else>Login</div>
              </button>
            </div>
          </form>
          <div style="font-size: 15px">
            Don't have an account?
            <a href="javascript:void(0)" @click="openRegisterModal()"
              >Register Now</a
            >
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div id="modal-register" class="uk-flex-top" uk-modal>
      <div
        class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical"
        style="width: 500px"
      >
        <button class="uk-modal-close-default" type="button" uk-close></button>

        <div class="uk-modal-header">
          <h2 class="uk-modal-title">Register</h2>
        </div>
        <form @submit.prevent="registerAction()">
          <div class="uk-modal-body">
            <div
              class="uk-alert-danger"
              uk-alert
              v-if="register.messageError != ''"
            >
              <a
                class="uk-alert-close"
                uk-close
                href="javascript:void(0);"
                @click="register.messageError = ''"
              ></a>
              <p>
                {{ register.messageError }}
              </p>
            </div>
            <div class="uk-flex uk-margin">
              <div class="uk-margin-right uk-width-1-2">
                <input
                  type="text"
                  class="uk-input"
                  placeholder="Fullname"
                  v-model="register.fullname"
                  required
                />
              </div>
              <div class="uk-width-1-2">
                <input
                  type="number"
                  class="uk-input"
                  placeholder="Phone"
                  v-model="register.phone"
                  required
                />
              </div>
            </div>
            <div class="uk-flex uk-margin">
              <div class="uk-width-1-1">
                <input
                  type="email"
                  class="uk-input"
                  placeholder="Email Address"
                  v-model="register.email"
                  required
                />
              </div>
            </div>
            <div class="uk-flex uk-margin">
              <div class="uk-width-1-1">
                <input
                  type="password"
                  class="uk-input"
                  placeholder="Password"
                  v-model="register.password"
                  required
                  min="6"
                />
              </div>
            </div>
            <div class="uk-flex uk-margin">
              <div class="uk-width-1-1">
                <input
                  type="password"
                  class="uk-input"
                  placeholder="Confirm Password"
                  v-model="register.confirm_password"
                  required
                  min="6"
                />
              </div>
            </div>
            <div class="uk-flex uk-margin">
              <div class="uk-width-1-1">
                <button
                  class="uk-button uk-button-primary uk-width-1-1"
                  :disabled="register.disabledButtonRegister"
                  type="submit"
                >
                  Register
                </button>
              </div>
            </div>
            <div class="uk-flex">
              <div style="font-size: 15px" class="uk-width-1-1">
                Already have an account?
                <a href="javascript:void(0)" @click="openLoginModal()"
                  >Login Here</a
                >
              </div>
            </div>
          </div>
        </form>
      </div>
    </div> -->
  </div>
</template>

<script>
import UIkit from "uikit";
import { mapActions, mapGetters, mapMutations } from "vuex";
import api from "@/api.js";
import axios from "axios";
export default {
  name: "NavigationBar",
  data() {
    return {
      topSearchForm: false,
      login: {
        email: "",
        password: "",
        loadingButtonLogin: false,
        messageError: "",
      },
      register: {
        fullname: "",
        phone: "",
        email: "",
        password: "",
        confirm_password: "",
        disabledButtonRegister: false,
        loadingButtonRegister: false,
        messageError: "",
      },
      showDropdownAccount: false,
      categories: [],
      fullnameTemp: "",
      keyword: "",
      menus: [],
      collectionsData: [
        {
          category: 'Smart TV',
          url: 'smart-tv',
          products: [
            {
              name: 'ROOMI T2 Digital TV',
            },
            {
              name: 'Smart Frameless Android TV',
            },
            {
              name: 'Smart TV WEB-OS 2.0',
            },
            {
              name: 'GOOGLE TV',
            },
          ]
        },
        {
          category: 'Smart Camera',
          url: 'smart-camera',
          products: [
            {
              name: 'SPYE',
            },
            {
              name: 'SPYE Night',
            },
            {
              name: 'SPYE Night Motion',
            },
            {
              name: 'SPYE Mini I',
            },
            {
              name: 'SPYE Mini II',
            }
          ]
        },
        {
          category: 'Smart LED',
          url: 'smart-led',
          products: [
            {
              name: 'Lumio',
            },
          ]
        },
        {
          category: 'Speaker',
          url: 'speaker',
          products: [
            {
              name: 'Soundwave',
            },
            {
              name: 'Rave BOX',
            },
            {
              name: 'Wakanda Series',
            },
            {
              name: 'ROOMI PRO Series',
            },
            {
              name: 'Sonic Portable',
            },
            {
              name: 'Echo Series',
            },
            {
              name: 'Grande',
            },
            {
              name: 'Velvet',
            },
          ]
        },
        {
          category: 'OTT BOX',
          url: 'ott-box',
          products: [
            {
              name: 'ROOMI OTT BOX',
            },
          ]
        }
      ]
    };
  },
  methods: {
    ...mapMutations("auth", ["SET_USER"]),
    ...mapMutations("cart", ["REMOVE_ALL_CART"]),
    ...mapActions("cart", ["getCarts"]),
    searchProduct() {
      if (this.$route.name == "SearchPage") {
        const keyword = this.$route.query.keyword;
        if (keyword != this.keyword) {
          this.$router.replace({ query: { keyword: this.keyword } });
        }
        this.$root.$emit("changeKeywordFooter");
        this.$root.$emit("SearchPage");
      } else {
        this.$router.push("/search?keyword=" + this.keyword);
      }
    },
    getFullName() {
      if (this.IS_AUTH) {
        this.fullnameTemp = this.GET_USER.fullname;
      }
    },
    showTopSearchForm: function () {
      if (this.topSearchForm) {
        this.topSearchForm = false;
      } else {
        this.topSearchForm = true;
      }
    },
    openRegisterModal: function () {
      const modalLogin = document.querySelector("#modal-login");
      const modalRegister = document.querySelector("#modal-register");
      UIkit.modal(modalLogin).hide();
      UIkit.modal(modalRegister).show();
    },
    openLoginModal() {
      const modalLogin = document.querySelector("#modal-login");
      const modalRegister = document.querySelector("#modal-register");
      UIkit.modal(modalRegister).hide();
      UIkit.modal(modalLogin).show();
    },
    loginAction() {
      const modalLogin = document.querySelector("#modal-login");
      this.login.messageError = "";
      this.loadingButtonLogin = true;
      this.showDropdownAccount = false;
      api
        .post("customer/auth/login", {
          username: this.login.email,
          password: this.login.password,
        })
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (data.msg == "Login Sukses") {
              this.getCarts(data.data.id);
              if (this.$route.query.back) {
                window.location.href = this.$route.query.back;
              } else {
                window.location.href = "/";
              }
              this.SET_USER(data.data);
              this.loadingButtonLogin = false;
              // this.login.email = "";
              // this.login.password = "";
              this.login.messageError = "";
              // UIkit.modal(modalLogin).hide();
              // window.scroll(0, 0)
            } else {
              this.login.messageError = data.msg;
            }
          } else {
            this.login.messageError = "Something went wrong!";
          }
        })
        .catch((err) => {
          console.log(err.message);
          this.login.messageError = "Something went wrong!";
        });
    },
    registerAction() {
      this.register.messageError = "";
      if (this.register.password.length >= 6) {
        if (this.register.password == this.register.confirm_password) {
          api
            .post("customer/auth/register", {
              email: this.register.email,
              fullname: this.register.fullname,
              password: this.register.password,
              no_hp: this.register.phone,
              from_code: "",
            })
            .then((res) => {
              if (res.status == 200) {
                const data = res.data;
                if (data.success == 1) {
                  if (this.$route.query.back) {
                    window.location.href = this.$route.query.back;
                  } else {
                    window.location.href = "/";
                  }
                  this.SET_USER(data.data);
                  this.loadingButtonLogin = false;
                  this.login.messageError = "";
                  this.getCarts(data.data.id);
                } else {
                  this.register.messageError =
                    "Email / Phone is already registered!";
                }
              } else {
                console.log(res.status);
                UIkit.notification({
                  message: "Something went wrong!",
                  status: "danger",
                });
              }
            })
            .catch((err) => {
              console.log(err);
              UIkit.notification({
                message: "Something went wrong!",
                status: "danger",
              });
            });
        } else {
          this.register.messageError = "Passwords are not the same";
        }
      } else {
        this.register.messageError = "Password of at least 6 characters";
      }
    },
    logout() {
      window.location.href = "/";
      this.SET_USER(null);
      this.REMOVE_ALL_CART();
    },
    closeDropdown() {
      this.showDropdownAccount = false;
    },
    getCategory() {
      api
        .post("product/get_category")
        .then((result) => {
          this.loading = false;
          if (result.status == 200) {
            const data = result.data;
            if (data.length > 0) {
              data.map((element) => {
                element.total_product = element.products.length;
                let tempProduct = [];
                if (element.total_product > 5) {
                  for (let i = 0; i < 5; i++) {
                    tempProduct.push(element.products[i]);
                  }
                } else {
                  tempProduct = element.products;
                }
                element.products = tempProduct;
              });
              this.categories = data;
            }
          } else {
            UIkit.notification({
              message: "Something went wrong!",
              status: "danger",
            });
          }
        })
        .catch((err) => {
          console.log(err.message);
          UIkit.notification({
            message: "Something went wrong!",
            status: "danger",
          });
        });
    },
    changeKeyword() {
      if (this.$route.name == "SearchPage") {
        const keyword = this.$route.query.keyword;
        if (keyword) {
          this.keyword = keyword;
        } else {
          this.keyword = "";
        }
      }
    },
    getMenu() {
      this.menus = [];
      axios.get(`${process.env.VUE_APP_API_ROOMI_URL}menu/v2`).then((res) => {
        if (res.status == 200) {
          const data = res.data;
          if (data.success) {
            this.menus = data.data;
          }
        }
      });
    },
    openCategory(category){
			this.$router.push({ name: 'category', params: { id: category } });
		},
    openProduct(product, category){
			this.$router.push({ name: 'product-detail', params: { categoryid: category, productid: this.replaceSpaceWithDash(product) } })
		},
    replaceSpaceWithDash(str) {
      return str.replace(/\s+/g, "-").toLowerCase();;
    },
  },
  computed: {
    ...mapGetters(["GET_NOTIF_ORDER"]),
    ...mapGetters("auth", ["IS_AUTH", "GET_USER"]),
    ...mapGetters("cart", ["COUNT_CART"]),
    disabledButtonLogin() {
      // return this.login.email == "" || this.login.password == "";
    },
  },
  mounted() {
    // console.log(this.GET_USER)
    // this.getCategory();
    this.getMenu();
    this.getFullName();
    if (this.$route.name == "Home") {
      if (this.$route.query.login == "true") {
        this.openLoginModal();
      }
    }
    if (this.$route.name == "SearchPage") {
      const keyword = this.$route.query.keyword;
      if (keyword) {
        this.keyword = keyword;
        this.topSearchForm = true;
      } else {
        this.$router.push("/store");
      }
    }
    this.$root.$on("NavigationBar", () => {
      this.getFullName();
    });
    this.$root.$on("changeKeywordNavigation", () => {
      this.changeKeyword();
    });
  },
};
</script>

<style scoped lang="less">
@import "../custom/custom.less";

.dropdown-right-custom {
  // top: 0px !important;
  width: max-content !important;
}

.uk-dropdown-shadow-none {
  box-shadow: 0 0px 0px #000 !important;
}

.uk-dropdown-mobile {
  left: 19px !important;
  padding-left: 20px !important
}

.categoryMenu:hover {
  font-weight: bold !important;
  text-decoration: underline;
}

#top-nav {
  z-index: 1;
  background-color: #23467c;
}

#top-nav nav,
#top-nav nav > * {
  background-color: #23467c;
}

#top-nav ul li a,
.subnav li a {
  font-size: 10px;
  font-weight: 500;
  color: rgb(255, 255, 255);
  letter-spacing: 0.05vw;
  margin: auto;
  padding: 0;
}

#top-nav .subnav-dropdown {
  width: 100% !important;
  left: 0 !important;
}

#top-nav ul.subnav li a {
  color: rgb(155, 156, 157);
  font-weight: 400;
}

#top-nav ul.subnav li.uk-nav-header {
  font-size: 0.85vw !important;
  color: rgb(65, 63, 66) !important;
  font-weight: 600;
}

#top-nav ul.subnav li a:hover {
  color: rgb(53, 70, 127);
}

#mobileNavbar {
  display: none;
}

@media screen and (max-width: 639px) {
  #mobileNavbar {
    display: inherit;
    max-height: 60px;
  }

  #mobileNavbar ul,
  #mobileNavbar li,
  #mobileNavbar a {
    min-height: 40px;
  }

  #offcanvas-slide ul li a {
    font-size: 14px;
    font-weight: 700;
  }

  #offcanvas-slide ul li.uk-nav-header {
    font-weight: 700 !important;
  }
}

#topSearchForm {
  width: 20vw;
}

#topSearchForm input {
  padding: 8px 10px;
  border: unset;
  border-radius: 10px;
  width: inherit;
  color: rgb(189, 190, 192);
}

#topSearchForm input:focus {
  outline: unset;
}

#topSearchForm input::placeholder {
  color: rgb(189, 190, 192);
  font-size: 10px;
  letter-spacing: 2px;
}

.cart-badge {
  background: white;
  color: @primary-color;
  position: absolute;
  top: -10px;
  font-size: 9px;
  height: 18px;
  min-width: 18px;
  right: -14px;
}

@media screen and (max-width: 959px) {
  .badge-notification-order {
    display: none;
  }
}

#top-nav {
  .badge-notification-order {
    background: @danger-color;
    color: white;
    font-size: 10px;
    min-width: 15px;
    height: 15px;
    float: right;
    margin-left: 10px;
    margin-top: 6px;
  }
  .badge-notification-mobile {
    background: @danger-color;
    color: white;
  }
  .dropdown-menu-user {
    position: absolute;
    right: 0;
    background: white;
    z-index: 1;
    padding: 10px 15px;
    box-shadow: 0px 5px 7px 0px rgba(0, 0, 0, 0.059);
    width: 220px;
    ul {
      list-style-type: none;
      padding-left: 0px;
      margin-bottom: 5px;
      li {
        a {
          color: #23467c;
          text-decoration: none;
          padding: 8px 30px;
          border-radius: 3px;
          display: block;
          position: relative;

          .uk-badge {
            font-size: 10px;
            float: right;
            min-width: 18px;
            height: 18px;
            background: @danger-color;
            position: absolute;
            right: 20px;
            top: 6px;
          }

          &:hover {
            background: @primary-color;
            color: white;
          }
        }
      }

      .dropdown-logout {
        a {
          color: @danger-color;
          &:hover {
            background: @danger-color;
            color: white;
          }
        }
      }
    }
  }
}
#offcanvas-slide {
  .uk-offcanvas-close {
    position: relative;
    z-index: inherit;
    top: 0;
    left: 0;
    padding: 0;
  }
}
</style>